// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowRegular-module_commonRowRegular__W3VIW {
    font: var(--typography-main);
    border: none;
    width: 100%;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    outline: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    vertical-align: top;
    cursor: pointer;
    pointer-events: auto;
    border-radius: 6px;
    gap: 16px;
    padding: 16px 24px;
    min-height: 72px;
    text-align: left;
    color: var(--row-regular-text);
    background: var(--row-regular-bg);

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--row-regular-bg-hovered);
        }
    }

    &:active {
        background: var(--row-regular-bg-pressed);
    }
}

.rowRegular-module_commonRowRegular__W3VIW.rowRegular-module_disabled__lTZQw {
    cursor: default;
    pointer-events: none;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: none;
        }
    }
}

.rowRegular-module_rowContent__Xmuq3 {
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: left;
}

.rowRegular-module_subtitleRow__URE2V {
    display: flex;
    align-items: center;
    min-width: 0;
}

.rowRegular-module_rowContent__Xmuq3 span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rowRegular-module_highlightedTitle__HntD5 {
    color: var(--row-regular-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rowRegular-module_highlightedTitle__HntD5.rowRegular-module_disabled__lTZQw {
    color: var(--row-regular-text-disabled);
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Row/styles/rowRegular.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,iCAAiC;;IAEjC;QACI;YACI,yCAAyC;QAC7C;IACJ;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;;IAEpB;QACI;YACI,gBAAgB;QACpB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;AAC3C","sourcesContent":[".commonRowRegular {\n    font: var(--typography-main);\n    border: none;\n    width: 100%;\n    box-sizing: border-box;\n    display: inline-flex;\n    align-items: center;\n    outline: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: relative;\n    vertical-align: top;\n    cursor: pointer;\n    pointer-events: auto;\n    border-radius: 6px;\n    gap: 16px;\n    padding: 16px 24px;\n    min-height: 72px;\n    text-align: left;\n    color: var(--row-regular-text);\n    background: var(--row-regular-bg);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--row-regular-bg-hovered);\n        }\n    }\n\n    &:active {\n        background: var(--row-regular-bg-pressed);\n    }\n}\n\n.commonRowRegular.disabled {\n    cursor: default;\n    pointer-events: none;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: none;\n        }\n    }\n}\n\n.rowContent {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    text-align: left;\n}\n\n.subtitleRow {\n    display: flex;\n    align-items: center;\n    min-width: 0;\n}\n\n.rowContent span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.highlightedTitle {\n    color: var(--row-regular-text);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.highlightedTitle.disabled {\n    color: var(--row-regular-text-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonRowRegular": `rowRegular-module_commonRowRegular__W3VIW`,
	"disabled": `rowRegular-module_disabled__lTZQw`,
	"rowContent": `rowRegular-module_rowContent__Xmuq3`,
	"subtitleRow": `rowRegular-module_subtitleRow__URE2V`,
	"highlightedTitle": `rowRegular-module_highlightedTitle__HntD5`
};
export default ___CSS_LOADER_EXPORT___;
